'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutGroup } from 'motion/react';
import { type RefCallback, useState } from 'react';
import { InfiniteList } from '@/components/ui/infinite-list';
import { Panel, PanelContent } from '@/components/ui/panel';
import { SuggestedOutcomesEmptyState } from './SuggestedOutcomesEmptyState';
import { SuggestedOutcomesHeader } from './SuggestedOutcomesHeader';
import { SuggestionFeedRow } from './SuggestionFeedRow';
import type { SuggestionWire } from './types';
export const SUGGESTIONS_PER_USER_PER_MARKET = 5;
interface SuggestedOutcomesPanelProps {
  marketCreator?: string;
  viewerPubkey: string | null;
  rows: ReadonlyArray<SuggestionWire>;
  reservedOutcomeIndexes?: Readonly<Record<string, number>>;
  itemObserver: (id: string) => RefCallback<Element>;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void | Promise<void>;
  onSuggest: () => void;
  onAddToMarket?: (suggestion: SuggestionWire) => void;
}
export function SuggestedOutcomesPanel(t0) {
  const $ = _c(40);
  const {
    marketCreator: t1,
    viewerPubkey,
    rows,
    reservedOutcomeIndexes: t2,
    itemObserver,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    onSuggest,
    onAddToMarket
  } = t0;
  const marketCreator = t1 === undefined ? "" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const reservedOutcomeIndexes = t3;
  const [sort, setSort] = useState("top");
  const isCreator = viewerPubkey !== null && viewerPubkey === marketCreator;
  let t4;
  if ($[2] !== rows || $[3] !== viewerPubkey) {
    t4 = viewerPubkey !== null ? rows.filter(row => row.suggesterPubkey === viewerPubkey).length : 0;
    $[2] = rows;
    $[3] = viewerPubkey;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const usedByViewer = t4;
  const remainingSuggestions = Math.max(0, SUGGESTIONS_PER_USER_PER_MARKET - usedByViewer);
  const canSuggest = isCreator || viewerPubkey === null || remainingSuggestions > 0;
  let T0;
  let T1;
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== canSuggest || $[6] !== fetchNextPage || $[7] !== hasNextPage || $[8] !== isCreator || $[9] !== isFetchingNextPage || $[10] !== itemObserver || $[11] !== onAddToMarket || $[12] !== onSuggest || $[13] !== reservedOutcomeIndexes || $[14] !== rows || $[15] !== sort) {
    let t11;
    if ($[24] !== sort) {
      t11 = (left, right) => (sort === "top" ? right.score - left.score : 0) || Date.parse(right.createdAt) - Date.parse(left.createdAt) || left.id.localeCompare(right.id);
      $[24] = sort;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    const sortedRows = [...rows].sort(t11);
    const promotedRows = sortedRows.filter(_temp);
    const activeRows = sortedRows.filter(_temp2);
    const isEmpty = rows.length === 0;
    T1 = Panel;
    t8 = "solid";
    t9 = "compact";
    t10 = "suggested-outcomes-panel";
    T0 = PanelContent;
    t5 = "flex flex-col gap-4";
    if ($[26] !== isEmpty || $[27] !== sort) {
      t6 = isEmpty ? null : <SuggestedOutcomesHeader sort={sort} onSortChange={setSort} />;
      $[26] = isEmpty;
      $[27] = sort;
      $[28] = t6;
    } else {
      t6 = $[28];
    }
    t7 = isEmpty ? <SuggestedOutcomesEmptyState onSuggest={onSuggest} canSuggest={canSuggest} isCreator={isCreator} /> : <LayoutGroup id="suggested-outcomes">{promotedRows.length > 0 ? <div className="flex flex-col gap-2" data-testid="suggested-outcomes-pinned">{promotedRows.map(suggestion => <div key={suggestion.id} ref={itemObserver(suggestion.id)}><SuggestionFeedRow suggestion={suggestion} isCreator={isCreator} isPromoted={true} {...reservedOutcomeIndexes[suggestion.id] === undefined ? {} : {
            reservedOutcomeIndex: reservedOutcomeIndexes[suggestion.id]
          }} /></div>)}</div> : null}{activeRows.length > 0 ? <InfiniteList hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} fetchNextPage={fetchNextPage} maxHeight={480} className="scrollbar-none"><div className="flex flex-col">{activeRows.map((suggestion_0, index) => <div key={suggestion_0.id} ref={itemObserver(suggestion_0.id)}><SuggestionFeedRow suggestion={suggestion_0} isCreator={isCreator} isPromoted={false} showSeparator={index > 0} {...isCreator && onAddToMarket !== undefined ? {
              onAddToMarket: () => onAddToMarket(suggestion_0)
            } : {}} /></div>)}</div></InfiniteList> : null}</LayoutGroup>;
    $[5] = canSuggest;
    $[6] = fetchNextPage;
    $[7] = hasNextPage;
    $[8] = isCreator;
    $[9] = isFetchingNextPage;
    $[10] = itemObserver;
    $[11] = onAddToMarket;
    $[12] = onSuggest;
    $[13] = reservedOutcomeIndexes;
    $[14] = rows;
    $[15] = sort;
    $[16] = T0;
    $[17] = T1;
    $[18] = t10;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[16];
    T1 = $[17];
    t10 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t11;
  if ($[29] !== T0 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7) {
    t11 = <T0 className={t5}>{t6}{t7}</T0>;
    $[29] = T0;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== T1 || $[35] !== t10 || $[36] !== t11 || $[37] !== t8 || $[38] !== t9) {
    t12 = <T1 surface={t8} density={t9} data-testid={t10}>{t11}</T1>;
    $[34] = T1;
    $[35] = t10;
    $[36] = t11;
    $[37] = t8;
    $[38] = t9;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
}
function _temp2(row_1) {
  return row_1.status === "active";
}
function _temp(row_0) {
  return row_0.status === "promoted" || row_0.status === "promoting";
}